import React, { memo, ReactNode, useCallback, useEffect, useState } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { ProductFamiliesProps } from './product-families';
import help from './product-families.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import notification from '@plasma/ui.feedback.notification';
import { deleteDataFromApiWithBody } from '../../services/Deletes/deleteData';
import { apiUriMasterDataHttp, apiUriProductFamilyHttp } from '../../services/conf/apiConf';

function useProductFamiliesHook(props: ProductFamiliesProps) {
  useResourceBundle(translations, undefined, '61ae4bc6-b21f-4245-ba4c-c1551b7904a8');
  useHelpBundle(help);

  const { t } = useTranslation();
  // State variables to store selected and inputted data
  const [familyName, setFamilyName] = useState('');
  const [productName, setProductName] = useState<any>();
  const [productDescription, setProductDescription] = useState<any>();
  const [addedItems, setAddedItems] = useState([]);
  const [dataToShowInCard, setdataToShowInCard] = useState();
  const [distinctProdName, setdistinctProdName] = useState([]);
  const [descriptionByProdName, setdescriptionByProdName] = useState([]);
  const [ModalVisible, setModalVisible] = useState(false);
  const [isInputVisible,setisInputVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [modalTitle, setmodalTitle] = useState('');
  const [booleanField, setbooleanField] = useState(false);

  useEffect (()=> {
    //Get all Family data to show in card
    fetchAllDataGet_byApiName("GetAllProductsFamilies", apiUriProductFamilyHttp()).then((response)=>{
      //set the response
      response.forEach((element) => {
        element.isHovered = false;
      });
      setdataToShowInCard(response);


    }).catch((error)=>{
      //console.log("error")
    });

    //Get Product Details data to insert in the dropdown fields
    fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((response)=>{
      //set the response
     const allProductName =  response.map((item) => item.producttype);
     const distProdName = allProductName.filter((value, index, self) => self.indexOf(value) === index);

     setdistinctProdName(distProdName);

    }).catch((error)=>{
      //console.log("error")
    });

  },[]);

  console.log("Data from GET call : ",dataToShowInCard);

//To set the options in the product description field
  useEffect(() => {

    fetchAllDataGet_byApiName("GetMasterProductDetails", apiUriMasterDataHttp()).then((response)=>{
     const descByName = response.filter(item => item.producttype === productName).map(item => item.productdescription);
     //console.log("setdescriptionByProdName Called to set everyting");

     const usedDescInFamilies = dataToShowInCard.filter(item => item.familyproducts.producttype === productName).map(item => item.familyproducts.productdescription);
     const descAfterFiltering = descByName.filter(item => !usedDescInFamilies.flat().includes(item));
     //console.log("PRODUCT NAMES, SETTING descAfterFiltering",descAfterFiltering);
     setdescriptionByProdName(descAfterFiltering);

     //console.log("Desc Used in Family: ",descAfterFiltering);

    }).catch((error)=>{
      //console.log("error")
    });

  },[productName]);


  //console.log("Data from prod details : ",descriptionByProdName);

  function handleFamilyNameChange(event: React.ChangeEvent<HTMLInputElement>) {
    setFamilyName(event.target.value);
  }

  function handleProductNameChange(value: string) {
    setProductName(value);
    setProductDescription(null);
    setMessage('');
  }

  function handleProductDescriptionChange(value: string) {
    setProductDescription(value);
    setMessage('');
  }


  const handleAddProduct = () => {
    //console.log("current Desc to  add", productDescription);
    console.log("pro name len: ",productName, productDescription);
    // console.log((!productName || productName === ''), (!productDescription  || productDescription === ''));
    // console.log((!productName || productName === '') && (!productDescription  || productDescription === ''));
    // console.log("check length",productName?.length && productDescription?.length && descriptionByProdName?.length);

     if (productName?.length && productDescription?.length && descriptionByProdName?.length ) {
      console.log("setdescriptionByProdName Called");
      // Check if the item already exists
      const itemExists = addedItems.some(item => item.productName === productName && item.productInfo === productDescription);

      if (!itemExists) {
        setAddedItems(currentItems => {
          // If currentItems is falsy or not an array, start with an empty array
          const itemsArray = Array.isArray(currentItems) ? currentItems : [];
          return [...itemsArray, { productName: productName, productInfo: productDescription }];
        });
      }

      const optionsAfterRemove = descriptionByProdName.filter(item => !(item === productDescription));
      console.log("setdescriptionByProdName Called");
      setdescriptionByProdName(optionsAfterRemove);
      console.log("Set Description : ", productDescription);
      setProductDescription(null);
      setMessage('');

    }
    else if((!productName || productName === '')) {
        setMessage('Please select a Product.');
      }
      else if((!productDescription || productDescription === '') && (descriptionByProdName?.length>0)) {
        setMessage('Please select a Dimension before adding.');
      }
      else if(descriptionByProdName.length=== 0){
        //console.log("Desc after add clicked: ",descriptionByProdName);
        setMessage('No more items in the Dimension list to be added.');
      }

  };


  const HandleSaveFamilyFromModal = () => {
    const transformedJSON = addedItems.reduce((acc, currentValue) => {
        // Check if the productType already exists in the accumulator
        if (!acc[currentValue.productName]) {
            // If not, initialize it with an empty array
            acc[currentValue.productName] = {
                producttype: currentValue.productName,
                productdescription: []
            };
        }
        // Push the productInfo value into the productDescriptions array
        acc[currentValue.productName].productdescription.push(currentValue.productInfo);
        return acc;
    }, {});

    // Construct the desired structure
    const JSONToSend = {
        productfamilyname: familyName,
        familyproducts: Object.values(transformedJSON)[0]
    };

    // Call POST api to save Family.
    sendAllDataPost_byApiNameAndData("AddProductFamily", JSONToSend, apiUriProductFamilyHttp())
      .then((response_1)=>{
          //Call GET api to update the data
      fetchAllDataGet_byApiName("GetAllProductsFamilies", apiUriProductFamilyHttp()).then((response)=>{
        //set the response
        setdataToShowInCard(response);
        notification.success('Success !', 'Family Saved Successfully', undefined, 'medium', 3)
      }).catch((error)=>{
        //console.log("error")
      });
    });



    setModalVisible(!ModalVisible);
    setProductName(null);
    setProductDescription(null);
    setFamilyName('');
    setAddedItems([]);
    console.log("Save button clicked : ", JSONToSend);


    //return JSONToSend;
}



  const HandleModalCancel = () => {
    setModalVisible(false);
    setProductName(null);
    setProductDescription(null);
    setFamilyName('');
    setAddedItems([]);
    setMessage('');
  }

  const removeItemFromAddedList = ((RemovedItem) => {
    const filteredArray = addedItems.filter(item => !(item.productName === RemovedItem.productName && item.productInfo === RemovedItem.productInfo));
    setAddedItems(filteredArray);
    console.log("setdescriptionByProdName Called from remove: ", descriptionByProdName);
    setdescriptionByProdName([...descriptionByProdName, RemovedItem.productInfo]);

    setMessage('');
     //console.log(addedItems);
  });

  const handleEdit =(item_func, e) => {

    setFamilyName(item_func.productfamilyname);
    setProductName(item_func.familyproducts.producttype);

    item_func.familyproducts.productdescription?.map((oneDesc) => {

      const itemExists = addedItems.some(item => item.productName === item_func.familyproducts.producttype && item.productInfo === oneDesc);

      if (!itemExists) {
        setAddedItems(currentItems => {
          // If currentItems is falsy or not an array, start with an empty array
          const itemsArray = Array.isArray(currentItems) ? currentItems : [];
          //console.log("adding ", { productName: item_func.familyproducts.producttype, productInfo: oneDesc })
          return [...itemsArray, { productName: item_func.familyproducts.producttype, productInfo: oneDesc }];
        });
      }
      //console.log(descriptionByProdName);
    });

    setModalVisible(true);
    setisInputVisible(true);
    setmodalTitle(`${t("edit")} ${item_func.productfamilyname}`);

    console.log("Desc clicking edit button : ",descriptionByProdName);
  }

  const handleDelete = (item) => {
    console.log("Data to delete : ",item);

    // POST Api to be called here to delete the specific data.
    deleteDataFromApiWithBody("DeleteProductFamily", item, apiUriProductFamilyHttp()).then((response_1)=>{
      //Call GET api to update the data
      fetchAllDataGet_byApiName("GetAllProductsFamilies", apiUriProductFamilyHttp()).then((response)=>{
        //set the response
        setdataToShowInCard(response);
        notification.error('Removed !', 'Family Deleted Permanently', undefined, 'medium', 3)
      }).catch((error)=>{
        //console.log("error")
      });
    });

  };

  const handleVisibilityFamNameAndModal = () =>{
    setModalVisible(!ModalVisible);
    setisInputVisible(false);
    setmodalTitle(t("create-new-family"));
  };

  const handleSetBoolean = (cardINdex: number, DidMouseEnter: boolean) => {
    const DatatoShowONCard = dataToShowInCard.map((item, index) => {
      if(index === cardINdex && DidMouseEnter){
        item.isHovered = true;
      }
      else{
        item.isHovered = false;
      }
      return item;
    })

    setdataToShowInCard(DatatoShowONCard);

  }


  return {
    t,
    handleFamilyNameChange,
    handleProductNameChange,
    handleProductDescriptionChange,
    handleAddProduct,
    familyName,
    productName,
    productDescription,
    addedItems,
    ModalVisible,
    isInputVisible,
    dataToShowInCard,
    distinctProdName,
    descriptionByProdName,
    message,
    modalTitle,
    booleanField,
    setbooleanField,
    setModalVisible,
    setisInputVisible,
    HandleSaveFamilyFromModal,
    HandleModalCancel,
    removeItemFromAddedList,
    handleEdit,
    handleDelete,
    setMessage,
    handleVisibilityFamNameAndModal,
    handleSetBoolean
  };
}

export default useProductFamiliesHook;
